export default __webpack_public_path__ + "static/media/ios-screen3.f19eddc9.png";